<section id="home" class="section welcome-area bg-overlay bg-overlay-color1-step3 overflow-hidden d-flex align-items-center" style="height: 500px; z-index: 1;">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <!-- Welcome Intro Start -->
            <div class="col-12 col-md-10">
                <div class="welcome-intro text-center mt-0 py-5">
                    <h1 class="text-white">Check out our previous work!</h1>
                </div>
            </div>
        </div>
    </div>
    
    <div class="shape shape-bottom" fxShow fxHide.lt-md>
        <svg viewBox="0 0 1000 100" fill="#FFF " xmlns="http://www.w3.org/2000/svg">
            <path class="shape-fill" d="M -2.917 60.549 C -2.917 60.549 9.658 44.231 62.049 53.089 C 102.378 59.908 202.626 86.023 359.177 36.397 C 525.951 -16.47 710.844 19.819 787.967 42.682 C 787.967 42.682 918.777 77.661 962.677 70.18 C 981.92 66.9 1003.421 58.455 1000.86 54.402 L 1000.102 -2.846 L -1.039 -1.805 L -2.917 60.549 Z"/>
          </svg>
    </div>
    <div class="shape shape-bottom" fxHide fxShow.lt-md style="bottom: -15px;">
        <svg viewBox="0 0 1000 100" fill="#FFF " xmlns="http://www.w3.org/2000/svg">
            <path class="shape-fill" d="M -2.917 60.549 C -2.917 60.549 9.658 44.231 62.049 53.089 C 102.378 59.908 202.626 86.023 359.177 36.397 C 525.951 -16.47 710.844 19.819 787.967 42.682 C 787.967 42.682 918.777 77.661 962.677 70.18 C 981.92 66.9 1003.421 58.455 1000.86 54.402 L 1000.102 -2.846 L -1.039 -1.805 L -2.917 60.549 Z"/>
          </svg>
    </div>
</section>
<section class="section case-studies ptb_100" style="margin-top: -15px;">
    <div class="container">
        <div *ngFor="let caseStudy of caseStudies; let i = index">
            <div class="row justify-content-center bg-white" *ngIf="i % 2 === 0"  [class.pt-100]="i !== 0">
                <div class="col-12 col-lg-7">
                    <!-- About Thumb -->
                    <div class="about-thumb text-center">
                        <img src="{{caseStudy.image}}" alt="">
                    </div>
                </div>
                <div class="col-12 col-lg-5">
                    <!-- About Content -->
                    <div class="about-content section-heading text-center text-lg-left pl-md-4 mt-5 mt-lg-0 mb-0">
                        <h2 class="mb-3">{{caseStudy.company}}</h2>
                        <p>{{caseStudy.paragraph1}}</p><br>
                        <p>{{caseStudy.paragraph2}}</p>
                    </div>
                </div>
            </div>
    
            <div class="row justify-content-center bg-white" style="padding-top: 100px;" *ngIf="i % 2 === 1" [class.pt-100]="i !== 0">
                <div class="col-12 col-lg-7" fxHide fxShow.lt-md>
                    <!-- About Thumb -->
                    <div class="about-thumb text-center">
                        <img src="{{caseStudy.image}}" alt="">
                    </div>
                </div>
                <div class="col-12 col-lg-5">
                    <!-- About Content -->
                    <div class="about-content section-heading text-center text-lg-left pl-md-4 mt-5 mt-lg-0 mb-0">
                        <h2 class="mb-3">{{caseStudy.company}}</h2>
                        <p>{{caseStudy.paragraph1}}</p><br>
                        <p>{{caseStudy.paragraph2}}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-7" fxShow fxHide.lt-md>
                    <!-- About Thumb -->
                    <div class="about-thumb text-center">
                        <img src="{{caseStudy.image}}" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>